import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ArcSharedModule } from '@arc/arc-shared-frontend';
import { translateFeature } from './reducers/translate.reducers';
import { TranslateEffects } from './effects/translate.effects';

@NgModule({
  imports: [
    ArcSharedModule,
    EffectsModule.forFeature([TranslateEffects]),
    StoreModule.forFeature(translateFeature),
  ],
  exports: [],
})
export class TranslateStoreModule {}
